<template>
  <div class="d-flex flex-column gap-2">
    <h6 class="mb-0">
      Envie o documento que comprove seu direito a meia entrada
    </h6>

    <b class="mb-0">Documentos aceitos</b>
    <v-list dense class="py-0">
      <v-list-item
        v-for="document in concessionTypes[type]?.allowed_documents"
        :key="document"
        class="d-flex align-center"
        style="min-height: 30px !important"
      >
        <v-icon small left>mdi-check</v-icon>
        <v-list-item-title>
          {{ document }}
        </v-list-item-title>
      </v-list-item>
    </v-list>

    <div>
      <b class="text-secondary d-block mb-2">Frente do documento</b>
      <v-alert v-if="files.documentFront" color="success" text>
        <div class="d-flex align-center gap-3">
          <div style="width: 40px; height: 40px">
            <v-icon
              v-if="files.documentFront.type === 'pdf'"
              left
              color="success"
            >
              mdi-file-pdf-box
            </v-icon>
            <v-img
              v-else
              :src="files.documentFront.url"
              width="40"
              height="40"
              contain
            />
          </div>
          <div class="flex-grow-1 flex-shrink-1" style="display: grid">
            <b class="text-truncate">{{ files.documentFront.file.name }}</b>
          </div>
          <v-spacer />
          <v-btn icon @click="handleFileChange('documentFront')">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </v-alert>
      <FileDrop
        v-else
        v-model="files.documentFront"
        @change="handleFileChange('documentFront', $event)"
        label="Frente do documento"
        accept="image/jpeg,image/jpg,image/png,application/pdf"
        acceptDescription="Imagens em formato JPG, PNG ou PDF (até 2MB)"
        :maxSize="2 * 1024 * 1024"
      />
    </div>

    <div>
      <b>Verso do documento</b>
      <small class="text-secondary d-block mb-2">Opcional</small>
      <v-alert v-if="files.documentBack" color="success" text dense>
        <div class="d-flex align-center gap-3">
          <div style="width: 40px; height: 40px">
            <v-icon
              v-if="files.documentBack.type === 'pdf'"
              left
              color="success"
            >
              mdi-file-pdf-box
            </v-icon>
            <v-img
              v-else
              :src="files.documentBack.url"
              width="40"
              height="40"
              contain
            />
          </div>
          <div class="flex-grow-1 flex-shrink-1" style="display: grid">
            <b class="text-truncate">{{ files.documentBack.file.name }}</b>
          </div>
          <v-spacer />
          <v-btn icon @click="handleFileChange('documentBack')">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </v-alert>
      <FileDrop
        v-else
        v-model="files.documentBack"
        @change="handleFileChange('documentBack', $event)"
        label="Verso do documento"
        accept="image/jpeg,image/jpg,image/png,application/pdf"
        acceptDescription="Imagens em formato JPG, PNG ou PDF (até 2MB)"
        :maxSize="2 * 1024 * 1024"
      />
      <!-- 2mb = 2 * 1024 * 1024 -->
    </div>
  </div>
</template>

<script>
import FileDrop from "@/components/global/FileDrop.vue";
import concessionTypes from "@/definitions/concessionTypes.json";
export default {
  name: "ConcessionFilesForm",
  components: {
    FileDrop,
  },
  emits: ["input"],
  props: {
    type: {
      type: String,
      default: null,
    },
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      concessionTypes,
    };
  },
  methods: {
    handleFileChange(type, file) {
      console.log(type, file);
      this.files = {
        ...this.files,
        [type]: file
          ? {
              file,
              type: file.type.includes("pdf") ? "pdf" : "image",
              url: URL.createObjectURL(file),
            }
          : null,
      };
    },
  },
  computed: {
    files: {
      get() {
        return (
          this.value || {
            documentFront: null,
            documentBack: null,
          }
        );
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
